import { byId } from "./dom";
import { showView } from "./navigation";

// quick starts for a gesture session: open the gesture screen, pick the seconds and the number of poses, and press start

export function startGesture(seconds: number, poses: number): void {
  showView("gesture");
  const press = (box: string, value: number) => document.querySelector<HTMLButtonElement>(`#${box} [data-value="${value}"]`)?.click();
  press("gesture-seconds", seconds);
  press("gesture-count", poses);
  window.setTimeout(() => byId<HTMLButtonElement>("gesture-start").click(), 120);
}

// the lengths offered from home widgets and draw today: [seconds, poses]
export const GESTURE_PRESETS: Array<[number, number]> = [[30, 5], [60, 10], [120, 20]];
